import React from 'react'
import { UpsellingActive, UpsellingActiveProperties } from './active/active'
import { UpsellingPending, UpsellingPendingProperties } from './pending/pending'

export interface UpsellingProperties {
    active: boolean
    feature?: UpsellingActiveProperties
    pending?: UpsellingPendingProperties
}

export function Upselling(properties: UpsellingProperties) {
    if (properties.feature && properties.active) {
        return <UpsellingActive {...properties.feature} />
    }

    if (properties.pending) {
        return <UpsellingPending {...properties.pending} />
    }

    return null
}
